/**
 * Utility functions for MCC (Merchant Category Code) related operations
 */

/**
 * Checks if a merchant has MCC ID 1 (0420 - Cannabis/Dispensary/Marijuana)
 * @param mccId - The MCC ID to check
 * @returns true if the merchant has MCC ID 1, false otherwise
 */
export const is0420Merchant = (mccId: number | undefined): boolean => {
  return mccId === 1;
};
